<script setup lang="ts">
import { computed } from 'vue';

import TextCheckOptions from '@/components/Jobs/CopilotActivation/TextCheckOptions.vue';
import MessageTemplate from '@/components/Shared/Input/Template/MessageTemplate.vue';
import { isRequired } from '@/utils/forms';
import Divider from '@/components/Shared/Divider/Divider.vue';

const props = defineProps<{
  isSelected: boolean;
  isPolicyLocked?: boolean;
  isDisabled?: boolean;
  employerCareerSiteUrl?: string | null;
}>();

const emit = defineEmits<{
  (e: 'select'): void;
  (e: 'update:employerCareerSiteUrl', value: string | null): void;
}>();

const isOptionLocked = computed(() => Boolean(props.isPolicyLocked || props.isDisabled));

const employerCareerSiteUrlModel = computed({
  get: () => {
    return props.employerCareerSiteUrl ?? '';
  },
  set: (value: string | null) => {
    emit('update:employerCareerSiteUrl', value);
  },
});

function handleSelect() {
  if (isOptionLocked.value) {
    return;
  }

  emit('select');
}
</script>

<template>
  <div class="relative" :class="{ 'opacity-75-disabled': isOptionLocked }">
    <TextCheckOptions
      :is-selected="isSelected"
      :is-disabled="isOptionLocked"
      :is-policy-locked="isPolicyLocked"
      @click="handleSelect"
    >
      <template #title>Redirect to careers page</template>
      Send candidates to your company's careers page to complete the application process

      <template v-if="isSelected" #action>
        <Divider class="my-4" />
        <p class="mb-0.5 text-xs font-bold text-shade-880">Careers page URL*</p>
        <v-text-field
          v-model="employerCareerSiteUrlModel"
          placeholder="Enter the URL for your careers page"
          variant="outlined"
          density="compact"
          :rules="[isRequired]"
          :disabled="isOptionLocked"
        >
          <template #message="{ message }">
            <MessageTemplate :message="message" />
          </template>
        </v-text-field>
      </template>
    </TextCheckOptions>
  </div>
</template>
